import { NamePath } from "antd/es/form/interface";
import * as React from "react";

import { dictViewsForTypes } from "../dictCompForTypes";
import { SelectComponent } from "./SelectComponent";

type PropsSelectViewComponent = {
  path: NamePath;
  value?: string;
  onChange?(value?: string): void;
};

export const SelectViewComponent: React.FC<PropsSelectViewComponent> = (
  props,
) => {
  const { path, value, onChange } = props;
  return (
    <SelectComponent
      path={path}
      dict={dictViewsForTypes}
      value={value}
      onChange={onChange}
    />
  );
};
